import React, { FC } from 'react'
import styles from 'styles/components/wysiwyg.module.scss'
import HTMLReactParser from 'html-react-parser'

type Props = {
  content: string
}

const WysiwygDisplayWrapper: FC<Props> = (props) => {
  const { content } = props
  return <div className={styles.preview}>{HTMLReactParser(content)}</div>
}

export default WysiwygDisplayWrapper
